import { axiosInstance } from "./apiConfig"

export const apiGetGeography = async (language = 'en') => {
    try {
        const response = await axiosInstance.get(`/geography/country?language=${language}`);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}


// WEBPACK FOOTER //
// ./src/api/apiGetGeography.js